// /search?q= — страница поиска (T137; ux.md, раздел 8): «Все результаты по «…»» палитры ⌘K.
// Любому вошедшему: что ищется, решают права ролей (features/search/sources.ts), поэтому своего
// права у раздела нет — как у профиля.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { SearchPage, parseSearchPageSearch } from '../../features/search/SearchPage.tsx';
import type { SearchPageSearch } from '../../features/search/SearchPage.tsx';

export const Route = createFileRoute('/_app/search')({
  validateSearch: parseSearchPageSearch,
  staticData: { crumb: 'Поиск' },
  component: SearchRoute,
});

function SearchRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: SearchPageSearch) => void navigate({ to: '/search', search: next, replace: true }),
    [navigate],
  );
  return <SearchPage search={search} onSearchChange={onSearchChange} />;
}
